export const LOCAL_STORAGE_KEYS = {
  cart: 'cart',
  personalInfo: 'personalInfo',
  lastOrderId: 'lastOrderId',
  lastOrderDate: 'lastOrderDate'
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const readLocalStorage = (key: string): any => {
  try {
    const result = localStorage?.getItem(key);

    if (!result) return null;

    return JSON.parse(result);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);

    return null;
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const writeLocalStorage = (key: string, value: any): void => {
  try {
    const valueString = JSON.stringify(value);

    localStorage?.setItem(key, valueString);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
};

export const removeLocalStorage = (key: string): void => {
  try {
    localStorage?.removeItem(key);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
};
